export default __webpack_public_path__ + "static/media/light_mode_white_24dp.6038b760.svg";